
export default class ResourceConnect {
    constructor(id, cscom) {
        if (!(this instanceof ResourceConnect)) {
            return new ResourceConnect(id, cscom);
        }
        this.cscom = cscom;
        this.id = id;

        if (this.id) {
            this.path = `/user-site-api/resource-connects/${this.id}`;
        } else {
            this.path = `/user-site-api/resource-connects`;
        }
    }
   
    sync(body) {
        return this.cscom.req.put(this.path + "/sync" , body).then((result) => {
            return result;
        });
    }

    reset() {      
        return this.cscom.req.put(this.path + "/reset").then((result) => {
            return result;
        });
    }


    get(data) {
        return this.cscom.req.get(this.path, null, data);
    }
    
    list(data) {
        return this.cscom.req.get(this.path, data);
    }

    search(data) {
        return this.cscom.req.get(this.path + '/search', data);
    }
 
}
